import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://cssbuy.biz";

const linhasEnvio = [
  { nome: "EMS", prazo: "7-15 dias", custo: "Médio", rastreio: "Sim", seguro: "Sim" },
  { nome: "EUB", prazo: "10-20 dias", custo: "Baixo", rastreio: "Parcial", seguro: "Opcional" },
  { nome: "SAL", prazo: "15-30 dias", custo: "Baixo", rastreio: "Sim", seguro: "Opcional" },
  { nome: "DHL", prazo: "5-10 dias", custo: "Alto", rastreio: "Sim", seguro: "Sim" },
  { nome: "Tax-Free Line", prazo: "10-18 dias", custo: "Médio", rastreio: "Sim", seguro: "Sim" },
];

const dicasEnvio = [
  "Consolide múltiplos itens em um único pacote para economizar no frete",
  "Use linhas tax-free para produtos de alto valor e evitar impostos adicionais",
  "Verifique o peso estimado antes de escolher a linha de envio",
  "Considere o seguro de envio para itens acima de determinado valor",
  "Acompanhe o rastreamento regularmente após o envio",
  "Guarde todos os comprovantes e fotos de QC para referência futura",
];

const faqEnvio = [
  { q: "Qual a melhor linha de envio do CSSBuy para o Brasil?", a: "A melhor linha depende do seu orçamento e urgência. A Tax-Free Line é excelente para evitar impostos adicionais, enquanto a EMS oferece bom equilíbrio entre custo e prazo. Para itens pequenos e econômicos, a EUB é uma boa opção." },
  { q: "Quanto custa o envio do CSSBuy para o Brasil?", a: "O custo do envio varia conforme o peso do pacote, a linha escolhida e o destino no Brasil. Pacotes pequenos (até 500g) podem custar a partir de R$30-50 em linhas econômicas, enquanto pacotes maiores podem chegar a R$200-400 em linhas expressas." },
  { q: "Como evitar taxas alfandegárias no envio do CSSBuy?", a: "Use linhas tax-free quando disponíveis, mantenha o valor declarado dentro de limites razoáveis, evite enviar muitos itens similares em um único pacote e considere o triangle shipping para maior proteção alfandegária." },
];

export default function GuiaEnvioPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"Article",
        "headline":"Guia de Envio CSSBuy para o Brasil: Melhores Opções e Dicas",
        "url": `${SITE_URL}/guia-envio`,
        "author":{"@type":"Person","name":"Equipe CSSBuy Brasil"},
        "datePublished":"2026-06-21","dateModified":"2026-06-27",
        "publisher":{"@type":"Organization","name":"CSSBuy Brasil","url": SITE_URL},
        "inLanguage":"pt-BR"
      })}} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"BreadcrumbList",
        "itemListElement":[
          {"@type":"ListItem","position":1,"name":"Início","item": `${SITE_URL}/`},
          {"@type":"ListItem","position":2,"name":"Guia de Envio CSSBuy","item": `${SITE_URL}/guia-envio`}
        ]
      })}} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"FAQPage",
        "mainEntity":[
          {"@type":"Question","name":"Qual a melhor linha de envio do CSSBuy para o Brasil?","acceptedAnswer":{"@type":"Answer","text":"A melhor linha depende do seu orçamento e urgência. A Tax-Free Line é excelente para evitar impostos adicionais, enquanto a EMS oferece bom equilíbrio entre custo e prazo. Para itens pequenos e econômicos, a EUB é uma boa opção."}},
          {"@type":"Question","name":"Quanto custa o envio do CSSBuy para o Brasil?","acceptedAnswer":{"@type":"Answer","text":"O custo do envio varia conforme o peso do pacote, a linha escolhida e o destino no Brasil. Pacotes pequenos (até 500g) podem custar a partir de R$30-50 em linhas econômicas, enquanto pacotes maiores podem chegar a R$200-400 em linhas expressas."}},
          {"@type":"Question","name":"Como evitar taxas alfandegárias no envio do CSSBuy?","acceptedAnswer":{"@type":"Answer","text":"Use linhas tax-free quando disponíveis, mantenha o valor declarado dentro de limites razoáveis, evite enviar muitos itens similares em um único pacote e considere o triangle shipping para maior proteção alfandegária."}}
        ]
      })}} />
      <Navbar />
      <main>
        <article className="pt-24 pb-16 md:pt-28 md:pb-24">
          <div className="max-w-4xl mx-auto px-4 md:px-8 mb-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400">
              <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer">Início</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">Guia de Envio CSSBuy</span>
            </nav>
          </div>
          <header className="max-w-4xl mx-auto px-4 md:px-8 mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">Envio</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">Guia de Envio CSSBuy para o Brasil: Melhores Opções e Dicas</h1>
            <p className="mt-4 text-foreground-500 text-base md:text-lg leading-relaxed max-w-2xl">Guia completo sobre <strong>envio do CSSBuy para o Brasil</strong>: linhas disponíveis, prazos, taxas alfandegárias, triangle shipping e dicas para receber seus produtos com segurança.</p>
            <div className="flex flex-wrap items-center gap-4 mt-6 text-xs text-foreground-400">
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-user-line"></i>Equipe CSSBuy Brasil</span>
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-calendar-line"></i>Atualizado: Junho 2026</span>
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-time-line"></i>8 min de leitura</span>
            </div>
            <div className="mt-8 rounded-2xl overflow-hidden h-[300px] md:h-[420px]">
              <img src="https://readdy.ai/api/search-image?query=International%20shipping%20concept%20with%20package%20boxes%20and%20globe%20on%20warm%20minimalist%20desk%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20logistics%20aesthetic%20global%20delivery%20theme%20shipping%20guide&width=1200&height=600&seq=art-page-guia-envio&orientation=landscape" alt="Guia de Envio CSSBuy" className="w-full h-full object-cover" />
            </div>
          </header>
          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <div className="text-foreground-700 leading-relaxed space-y-8">
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Linhas de Envio do CSSBuy para o Brasil</h2>
                <p className="text-base leading-relaxed">
                  O <strong>CSSBuy</strong> oferece diversas opções de envio para o Brasil, cada uma com características específicas de prazo, custo e segurança. Nossa <strong>planilha CSSBuy</strong> inclui recomendações detalhadas sobre qual linha escolher para cada tipo de produto.
                </p>
                <div className="mt-6 overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-background-200">
                        <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase whitespace-nowrap">Linha</th>
                        <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase whitespace-nowrap">Prazo</th>
                        <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase whitespace-nowrap">Custo</th>
                        <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase whitespace-nowrap">Rastreio</th>
                        <th className="text-left py-3 text-foreground-500 font-medium text-xs uppercase whitespace-nowrap">Seguro</th>
                      </tr>
                    </thead>
                    <tbody>
                      {linhasEnvio.map((row, i) => (
                        <tr key={i} className={`border-b border-background-100 ${i === 4 ? 'bg-primary-50/50' : ''}`}>
                          <td className="py-3 pr-4 text-foreground-900 text-xs font-semibold whitespace-nowrap">{row.nome}</td>
                          <td className="py-3 pr-4 text-foreground-700 text-xs whitespace-nowrap">{row.prazo}</td>
                          <td className="py-3 pr-4 text-foreground-700 text-xs whitespace-nowrap">{row.custo}</td>
                          <td className="py-3 pr-4 text-foreground-700 text-xs whitespace-nowrap">{row.rastreio}</td>
                          <td className="py-3 text-foreground-700 text-xs whitespace-nowrap">{row.seguro}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Dicas para Envio com CSSBuy</h2>
                <div className="bg-background-100 rounded-2xl p-6">
                  <ul className="space-y-3">
                    {dicasEnvio.map((item, i) => (
                      <li key={i} className="flex items-start gap-3 text-sm">
                        <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </section>
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Perguntas Frequentes</h2>
                <div className="space-y-4">
                  {faqEnvio.map((item, i) => (
                    <div key={i} className="bg-background-100 rounded-xl p-5">
                      <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.q}</h4>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  ))}
                </div>
              </section>
              <section>
                <div className="bg-foreground-900 rounded-3xl p-8 md:p-10 text-center">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">Escolha o Melhor Envio com Nossa Planilha</h2>
                  <p className="text-background-50/60 text-sm md:text-base max-w-lg mx-auto mb-6">Use nosso CSSBuy Spreadsheet para encontrar os melhores produtos e nossas recomendações de envio para o Brasil.</p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer">cssbuy sheet<i className="ri-arrow-right-up-line ml-2"></i></a>
                    <Link to="/" className="px-8 py-3.5 rounded-full border border-background-50/20 text-background-50/70 text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer">← Voltar ao Início</Link>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}